import React from 'react';

import { FatalErrorProvider } from '@services/errorService';
import { EPage, ReactFCV } from '@types';

import { LoadableRoute } from '../../LoadableRoute';
import { RouteHelmet } from '../../RouteHelmet';

interface ICartRouteProps {
  page: EPage;
  component: React.FunctionComponent;
  skeletonComponent: React.FunctionComponent;
}

export const CartRoute: ReactFCV<ICartRouteProps> = ({ page, component, skeletonComponent }) => (
  <>
    <RouteHelmet page={page} />
    <FatalErrorProvider>
      <LoadableRoute component={component} skeletonComponent={skeletonComponent} />
    </FatalErrorProvider>
  </>
);
